module.exports = __webpack_public_path__ + "static/media/content-api-graphql.1826a700.gif";